import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { MailInfo } from './../../../model/mail-info.model';
import { Router } from '@angular/router';
import { PageEnums } from 'src/app/shared/enum/page-enums';
import { ActionLogForOffer } from '../../../model/action-log-for-offer.model';
@Component({
  selector: 'app-card-action-area',
  templateUrl: './card-action-area.component.html',
  styleUrls: ['./card-action-area.component.scss']
})
export class CardActionAreaComponent implements OnInit {
  @Input() mailInfo: MailInfo;
  @Input() mailType: string;
  @Input() page: string; // 存在するページ
  @Input() pairMail: MailInfo; // ペアメール
  @Input() editEvent: EventEmitter<void>;
  @Input() actionLogId: number;

  @Input() actionLogForOffer: ActionLogForOffer;
  @Input() offer: any;
  @Input() result: any; // 自動マッチングページの提案管理送信済みフラグ(result.matching.is_already_offerd)を変更するために使用

  @Output() deleted = new EventEmitter<any>();
  @Output() changeStatus = new EventEmitter<any>();

  @Input() workerMail: MailInfo;
  @Input() projectMail: MailInfo;
  @Input() offerType: string; // 1:案件確認依頼, 2:人材確認依頼

  offerPage = PageEnums.offer;
  workerListPage = PageEnums.project_list;
  projectListPage = PageEnums.worker_list;
  constructor(private router: Router) {}

  ngOnInit() {}

  changeShowOnlyImportantLine(mailInfo) {
    mailInfo.showOtherThanImportantLine = !mailInfo.showOtherThanImportantLine;
  }

  // 引数のai_mail_idを持ってるcard_headerをchildrenから抽出して、メール編集メソッドの呼び出し
  onCorrectMail() {
    this.editEvent.emit();
  }

  onDeletedMail() {
    if (this.page === this.mailType) {
      this.router.navigate(['/matching/${this.page}s']);
    }
    this.deleted.emit();
  }
}
